export function getEulLeul(word: string): string {
  if (!word) {
    return ""; // 빈 문자열 처리
  }

  const lastChar = word.slice(-1); // 마지막 글자 추출
  const charCode = lastChar.charCodeAt(0);

  // 한글 범위 확인 (가 ~ 힣)
  if (charCode < 0xac00 || charCode > 0xd7a3) {
    return ""; // 한글이 아니면 조사를 붙이지 않거나 판단 불가
  }

  const jongsungCode = (charCode - 0xac00) % 28; // 종성 코드 계산

  if (jongsungCode === 0) {
    return "를"; // 받침 없음
  } else {
    return "을"; // 받침 있음
  }
}

export function attachEulLeul(word: string): string {
  return `${word}${getEulLeul(word)}`;
}
